import Spinner from '@/common/components/Spinner'
import useMutationUpdateOperator from '../../api/hooks/useMutationUpdateOperator'
import useQueryGetOperatorById from '../../api/hooks/useQueryGetOperatorById'
import OperatorForm from '@/modules/manage-operator/components/OperatorForm'

export const AdminUpdateOperatorForm = ({
	operatorId,
}: {
	operatorId: string
}) => {
	const { data: operator, isLoading } = useQueryGetOperatorById(operatorId)
	const { mutateAsync: mutateUpdateOperator } =
		useMutationUpdateOperator(operatorId)

	if (isLoading) return <Spinner />

	return (
		<OperatorForm
			key={`${operator?.id}-${operator?.updatedAt}`}
			defaultValue={operator}
			handleSubmit={mutateUpdateOperator}
		/>
	)
}
